module.exports = __webpack_public_path__ + "img/m14.808bc62.jpg";